<style lang="scss" src='./UserAddress.scss' scoped></style>
<template src="./UserAddress.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";

  import router from '@/router';

  import InvalidAddressModal from '../../../../components/invalidAddressModal/InvalidAddressModal'

  export default {
    name: "UserAddress",
    components: {
      InvalidAddressModal,
    },
    data() {
      return {
        address: null,
        notes: null,
        number_2: null,
        autocompleteInput: null,
        map: null,
        google: null,
        mapMarker: null,
        userAddress: {
          country_code: null,
          address: null,
          latitude: null,
          longitude: null,
          zip_code: null,
          street: null,
          number: null,
          locality: null,
          city: null,
          state: null,
          country: null,
        },
        defCoords: {
          lat: 25.6563213,
          lng: -100.2986277
        },
        loading: false,
      }
    },
    computed: {
      ...mapState(['user']),
      ...mapState('CartStore', ['cartProducts']),
      ...mapState('Main',['storeList', 'currentStore']),
    },

    methods: {
      ...mapActions('CartStore', ['fnApiSetDeliveryMethod']),
      ...mapActions(['fnApiGetMe',]),
      ...mapMutations('Main',['setCurrentStore']),
      ...mapMutations(['setInvalidAddressModal']),

      async fnInitMap({
        lat = 0,
        lng = 0
      }) {
        const mapOptions = {
          zoom: 14,
          center: {
            lat,
            lng
          },
          controlOptions: {
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
          },
        };
        this.consts.Google.MAP = this.consts.Google.MAP ? this.consts.Google.MAP : await this.consts.Google.MAP_LOADER.load();
        this.map = new this.consts.Google.MAP.maps.Map(document.getElementById('userMap'), mapOptions);

        if (this.user.latitude && this.user.longitude) {
          this.setUserLocation({
            lat: this.user.latitude,
            lng: this.user.longitude
          }, true);
        }
      },

      async G_initMapPlaces(input) {
        this.consts.Google.MAP = this.consts.Google.MAP ? this.consts.Google.MAP : await this.consts.Google
          .MAP_LOADER.load();
        const autocomplete = new this.consts.Google.MAP.maps.places.Autocomplete(input, {
          types: ['address']
        });
        return autocomplete;
      },

      async G_initMap({
        mapId,
        zoom,
        center,
        controlOptions
      }) {
        this.consts.Google.MAP = this.consts.Google.MAP ? this.consts.Google.MAP : await this.consts.Google
          .MAP_LOADER.load();

        let mapOptions = {
          zoom,
          center,
          mapTypeId: this.consts.Google.MAP.maps.MapTypeId.SATELLITE
        };
        if (controlOptions) {
          mapOptions = {
            ...mapOptions,
            ...controlOptions
          };
        }
        const mapInstance = new this.consts.Google.MAP.maps.Map(
          document.getElementById(mapId), mapOptions,
        );
        return mapInstance;
      },

      async loadData() {
        this.autocompleteInput = await this.G_initMapPlaces(this.$refs.inputAddress);
        this.consts.Google.MAP.maps.event.addListener(this.autocompleteInput, 'place_changed', this.onAddressChanged);
      },

      onAddressChanged() {
        const place = this.autocompleteInput.getPlace();
        let invalidAddress = true;
        if (place) {
          if (place.geometry && place.geometry.location) {
            const country_code = this.findInGooglePlaceResult(place.address_components, 'country', 'short_name');
            if (country_code) {
              const latLong = place.geometry.location;
              this.setAddress({
                country_code,
                address: place.formatted_address,
                latitude: latLong.lat(),
                longitude: latLong.lng(),
                zip_code: this.findInGooglePlaceResult(place.address_components, 'postal_code', 'long_name'),
                street: this.findInGooglePlaceResult(place.address_components, 'route', 'long_name'),
                number: this.findInGooglePlaceResult(place.address_components, 'street_number', 'long_name'),
                locality: this.findInGooglePlaceResult(place.address_components, 'sublocality', 'long_name'),
                city: this.findInGooglePlaceResult(place.address_components, 'locality', 'long_name'),
                state: this.findInGooglePlaceResult(place.address_components, 'administrative_area_level_1', 'long_name'),
                country: this.findInGooglePlaceResult(place.address_components, 'country', 'long_name')
              }, true);
              invalidAddress = false;
            }
          }
        }
        if (invalidAddress) {
          this.setAddress({
            country_code: null,
            address: null,
            latitude: null,
            longitude: null,
            zip_code: null,
            street: null,
            number: null,
            locality: null,
            city: null,
            state: null,
            country: null,
          });
        }
      },

      setAddress({
        country_code,
        address,
        latitude,
        longitude,
        zip_code,
        street,
        number,
        locality,
        city,
        state,
        country
      }, changeMarker) {
        this.address = address;
        this.userAddress.country_code = country_code;
        this.userAddress.address = address;
        this.userAddress.latitude = latitude;
        this.userAddress.longitude = longitude;
        this.userAddress.zip_code = zip_code;
        this.userAddress.street = street;
        this.userAddress.number = number;
        this.userAddress.locality = locality;
        this.userAddress.city = city;
        this.userAddress.state = state;
        this.userAddress.country = country;
        if (changeMarker) {
          this.G_addMarkerToMap({
            lat: latitude,
            lng: longitude
          }, null, this.setUserLocation)
        }
      },

      findInGooglePlaceResult(addressComponents, addressType, field) {
        if (addressComponents && addressComponents.length > 0) {
          const address_component = addressComponents.find(address => address.types.includes(addressType));
          if (address_component) {
            return address_component[field];
          }
        }
        return null;
      },

      G_addMarkerToMap({
        lat,
        lng
      }, icon, onLocationSet) {
        const self = this;

        if (onLocationSet) {
          onLocationSet({
            lat,
            lng
          });
        }

        if (self.mapMarker != null) {
          self.mapMarker.setMap(null);
        }
        self.mapMarker = new window.google.maps.Marker({
          position: {
            lat,
            lng
          },
          draggable: true,
          icon: icon ? icon : '',
        });
        self.mapMarker.setAnimation(this.consts.Google.MAP.maps.Animation.BOUNCE);
        self.mapMarker.setMap(self.map);

        // eslint-disable-next-line
        setTimeout(function () {
          self.mapMarker.setAnimation(null);
        }, 1500);
        this.consts.Google.MAP.maps.event.addListener(self.mapMarker, 'dragend', function () {

          if (onLocationSet) {
            const position = self.mapMarker.getPosition();
            onLocationSet({
              lat: position.lat(),
              lng: position.lng()
            });
          }
        });
        self.map.setCenter(new window.google.maps.LatLng(lat, lng));

        if (lat) {
          self.map.setZoom(18);
        }
      },

      G_findCurrentLocation() {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        };
        if (navigator.geolocation) {

          navigator.geolocation.getCurrentPosition((position) => {
            this.G_addMarkerToMap({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }, null, this.setUserLocation);
          }, () => {
            this.G_addMarkerToMap({
              lat: 25.6563213,
              lng: -100.2986277
            }, null, this.setUserLocation);
          }, options);

        } else {
          alert("Geolocation is not supported by this browser.");
        }
      },

      setUserLocation({
        lat,
        lng
      }, changeMarker) {
        const geocoder = new this.consts.Google.MAP.maps.Geocoder();
        geocoder
          .geocode({
            location: {
              lat,
              lng
            }
          })
          .then((response) => {
            let place = response.results[0];
            if (place.geometry && place.geometry.location) {
              const country_code = this.findInGooglePlaceResult(place.address_components, 'country', 'short_name');
              if (country_code) {
                const latLong = place.geometry.location;
                this.setAddress({
                  country_code,
                  address: place.formatted_address,
                  latitude: latLong.lat(),
                  longitude: latLong.lng(),
                  zip_code: this.findInGooglePlaceResult(place.address_components, 'postal_code', 'long_name'),
                  street: this.findInGooglePlaceResult(place.address_components, 'route', 'long_name'),
                  number: this.findInGooglePlaceResult(place.address_components, 'street_number', 'long_name'),
                  locality: this.findInGooglePlaceResult(place.address_components, 'sublocality', 'long_name'),
                  city: this.findInGooglePlaceResult(place.address_components, 'locality', 'long_name'),
                  state: this.findInGooglePlaceResult(place.address_components, 'administrative_area_level_1', 'long_name'),
                  country: this.findInGooglePlaceResult(place.address_components, 'country', 'long_name')
                }, changeMarker);
              }
            }
          });
        this.userAddress.latitude = lat;
        this.userAddress.longitude = lng;
      },

      async fnValidate() {
        if (await this.$refs['formAddress'].validate()) {
          let tempBody = {
            ...this.userAddress,
            type: 'DELIVERY',
          };
          this.notes && (tempBody.notes = this.notes);
          this.number_2 && (tempBody.number_2 = this.number_2);
          this.loading = true;
          let result = await this.fnApiSetDeliveryMethod(tempBody);
          if(result){

            if(result.error_code){
              if(result.error_code == 43){
                this.setInvalidAddressModal(true);
              }else{
                this.$notify({
                  text: this.$t('general.unexpectedError'),
                  type: 'error',
                });
              }
            }else{
              if(this.currentStore.store_id != result.store_id){
                let store = this.storeList.find(x => x.store_id == result.store_id);
                if(store){
                  this.setCurrentStore(store);
                }
              }
  
              if (tempBody.type == 'DELIVERY') {
                router.push('/payment/schedule');
              } else {
                router.push('/payment/summary');
              }
            }
          }
          this.loading = false;
        }
      }
    },

    beforeCreate() {},

    created() {},

    async mounted() {
      await this.fnApiGetMe();
      this.loadData();
      await this.fnInitMap(this.defCoords);
      if (this.user.notes) {
        this.notes = this.user.notes.toString();
      }
      if (this.cartProducts.delivery_method?.notes) {
        this.notes = this.cartProducts.delivery_method?.notes.toString();
      }
      this.number_2 = this.user && this.user.number_2 ? this.user.number_2 : null;
      this.setInvalidAddressModal(false)
    },

    beforeDestroy() {
    },

  };

</script>
